(() => {
  angular
    .module('complianceFrameworkApp.complianceServices')
    .controller('CalendarController', CalendarController);

  /* ngInject */
  function CalendarController($document, $scope, $state, $stateParams, agencyTypes, calendarEventTypes, calendarProposalStatuses, config, eventService, sessionService) {
    const vm = this;

    vm.agencyTypes = agencyTypes;
    vm.calendarEventTypes = calendarEventTypes;
    vm.calendarProposalStatuses = calendarProposalStatuses;
    vm.calendar = null;
    vm.currentPage = $stateParams.currentPage || 1;
    vm.events = [];
    vm.eventView = 'calendar';
    vm.filterAgencyTypes = [];
    vm.filterEventTypes = [];
    vm.filterProposalStatuses = [];
    vm.loading = false;
    vm.pageChange = pageChange;
    vm.refreshEvents = refreshEvents;
    vm.setEventView = setEventView;
    vm.sessionService = sessionService;
    vm.showFilters = true;
    vm.totalCount = null;

    initializeCalendar();
    getEvents();

    $scope.$on('$destroy', function() {
      angular.element('.popover').remove();
    });

    $scope.$watch('vm.filterEventTypes', function() {
      vm.refreshEvents();
    }, true);

    $scope.$watch('vm.filterProposalStatuses', function() {
      vm.refreshEvents();
    }, true);

    $scope.$watch('vm.filterAgencyTypes', function() {
      vm.refreshEvents();
    }, true);

    /* eslint-disable no-undef */
    function initializeCalendar() {
      var calendarEl = $document[0].getElementById('calendar');
      vm.calendar = new FullCalendar.Calendar(calendarEl, {
        timeZone: 'UTC',
        plugins: [ 'dayGrid' ],
        header: {
          left: 'title',
          center: '',
          right: 'today prev,next'
        },
        displayEventTime : false,
        events: function(info, successCallback, failureCallback) {
          eventService(sessionService.getAuthToken()).calendar({ 
            start_date: info.start, 
            end_date: info.end, 
            'event_types[]': vm.filterEventTypes,
            'proposal_statuses[]': vm.filterProposalStatuses,
            'agencies[]': vm.filterAgencyTypes
          }, response => {
            var calendarEvents = response.map(event => {
              return {
                id: event.id,
                title: event.title,
                start: event.start_at,
                end: event.end_at,
                url: `/compliance_services/events/${event.id}`,
                textColor: '#ffffff',
                backgroundColor: _getEventBackgroundColor(event.proposal_status),
                short_description: event.short_description
              };
            });

            var mandatoryEvents = response.map(event => {
              return {
                id: event.id,
                title: event.mandatory_title || event.title,
                start: event.mandatory_at || moment('1975', 'yyyy'),
                url: `/compliance_services/events/${event.id}`,
                textColor: '#ffffff',
                backgroundColor: _getEventBackgroundColor(event.proposal_status),
                short_description: event.short_description
              };
            });

            var effectiveEvents = response.map(event => {
              return {
                id: event.id,
                title: event.effective_title || (event.title),
                start: event.effective_at || moment('1975','yyyy'),
                url: `/compliance_services/events/${event.id}`,
                textColor: '#ffffff',
                backgroundColor: _getEventBackgroundColor(event.proposal_status),
                short_description: event.short_description
              };
            });

            successCallback(calendarEvents.concat(mandatoryEvents, effectiveEvents));
          }, error => {
            failureCallback(error);
          });
        },
        timeFormat: ' ',
        eventRender: function(info) {
          angular.element(info.el).popover({
            animation: true,
            delay: 300,
            html: true,
            title: info.event.title || '',
            content: info.event.extendedProps.short_description || '',
            trigger: 'hover'
          }).popover('show');
        }
      });
      vm.calendar.render();

    }
    /* eslint-enable no-undef */

    function getEvents() {
      eventService(sessionService.getAuthToken()).query({ 
        page: vm.currentPage,
        'event_types[]': vm.filterEventTypes,
        'proposal_statuses[]': vm.filterProposalStatuses,
        'agencies[]': vm.filterAgencyTypes
      }, response => {
        vm.loading = false;
        vm.events = response.data;
        vm.totalCount = parseInt(response.headers['x-total']);
      });
    }

    function pageChange(newPageNumber, _oldPageNumber) {
      vm.events = [];
      vm.currentPage = newPageNumber;
      getEvents();
    }

    function refreshEvents() {
      if (vm.calendar) {
        vm.calendar.refetchEvents();
      }

      vm.events = [];
      vm.currentPage = 1;
      getEvents();
    }

    function setEventView(eventView) {
      vm.eventView = eventView;
    }

    function _getEventBackgroundColor(eventType) {
      switch(eventType) {
      case 'notice':
        return '#003e75';
      case 'guidance':
        return '#38aae1';
      case 'final_rule':
        return '#28a745';
      case 'proposed':
        return '#dc3545';
      case 'reports':
        return '#ffc107';
      case 'news':
        return '#17a2b8';
      case 'training':
        return '#343a40';
      case 'request_for_information':
        return '#563d7c';
      case 'my_events':
        return '#c0392b';
      default:
        return '#f8f9fa';
      }
    }
  }
})();
